import React from 'react';
import { Grid, Box, Typography } from '@mui/material';
import { PromptsGrid as StyledPromptsGrid } from '../StyledComponents';
import PromptCard from './PromptCard';
import { PromptsGridProps } from '../types';

const PromptsGrid: React.FC<PromptsGridProps> = ({
  prompts,
  onPromptSelect,
  loading
}) => {
  if (prompts.length === 0) {
    return (
      <Box sx={{ 
        textAlign: 'center', 
        py: 8,
        color: '#64748b'
      }}>
        <Typography variant="h6" sx={{ mb: 1 }}>
          No prompts found
        </Typography>
        <Typography variant="body2">
          Try adjusting your search or category filter
        </Typography>
      </Box>
    );
  }

  return (
    <StyledPromptsGrid>
      <Grid container spacing={1}>
        {prompts.map((prompt, index) => (
          <Grid item xs={12} sm={4} md={4} key={prompt.id}>
            <PromptCard
              prompt={prompt}
              onClick={() => onPromptSelect({action:prompt.action, title:prompt.title})}
              loading={loading}
              index={index}
            />
          </Grid>
        ))}
      </Grid>
    </StyledPromptsGrid>
  );
};

export default PromptsGrid;
